import { useRef } from 'react';

// Shared touch-tracking for forms with a weight/qty input (the "primary"
// field) and a derived pcs input. The primary field becomes "touched" the
// moment the user edits it; until then a pcs edit may back-propagate into it
// (auto-fill / keep it in sync). Once touched, pcs edits leave the primary
// field alone. Used by BusinessOrdering, AdminInventory and the fulfillment
// form in AdminOrders so all three behave identically.
export function usePrimaryTouched() {
  const touchedRef = useRef(new Set());

  const markTouched = (key) => {
    touchedRef.current.add(key);
  };

  const untouch = (key) => {
    touchedRef.current.delete(key);
  };

  const isTouched = (key) => touchedRef.current.has(key);

  return { markTouched, untouch, isTouched };
}
